/*  MUI  */
import { Typography } from '@mui/material';

/*  React  */
import React, { Component } from 'react';

/*  Components  */
import { DataCard } from './Components/DataCard';

const format = (number) => {
    // Nine zeros for Billions
    if (Number(number) >= 1.0e9) {
        return `${(number / 1.0e9).toFixed(2)}B`;
    }

    // Six zeros for Millions
    if (Number(number) >= 1.0e6) {
        return `${(number / 1.0e6).toFixed(2)}MM`;
    }

    // Thrhee zeros for Thousands
    if (Number(number) >= 1.0e3) {
        return `${(number / 1.0e3).toFixed(2)}K`;
    }

    return number;
};

class Total extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({ loaded: true });
    };

    render() {
        const { total, title } = this.props;
        const { loaded } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <DataCard title={title}>
                <Typography color="text.cardKPI" variant="h1">
                    {format(total)}
                </Typography>
            </DataCard>
        );
    }
}
export default Total;
